import React, { Fragment } from 'react'
import { CircleButton, Label } from '../../../components'
import { getKeyOfOpt, lookupOption } from './optionUtils'
import DropDown from './dropdown'

import {
  ReactComponent as CloseIcon,
} from '../../../images/icons/times-pro.svg'
import styled from 'styled-components'

const ChildLabel = styled.label`
  background-color: ${props => props.theme.colorTable.backLight};
  color: ${props => props.theme.colorTable.backLightText};
  flex-grow: 1;
  padding: 0.375rem 0.75rem;
`

const DropDownList = (props) => {
  const {
    id,
    name,
    label,
    helpText,
    value,
    context,
    rtOptions,
    optionQuery,
    optFields,
    optionKeyName,
    getOptionTextFn,
    isInsideModal,
  } = props

  // value is an array of JS objects, but they may be outdated values -- if options are userData (from evaluation)
  // they may have changed. In this case, look up current values using key!
  const newValue = optionQuery
    ? value
    : value && value.reduce((previous, current) => {
    const newOpt = lookupOption(getKeyOfOpt(current, optionKeyName), rtOptions)
    return newOpt ? [...previous, newOpt] : previous
  }, [])
  // if (newValue && !newValue.length) {
  //   newValue = null
  // }

  // Create a temporary ArrayState to facilitate display of selected values
  const listState = context.getSelectionContext(name, newValue /* || -1 */)

  return (
    <Fragment>
      <Label name={name} label={label} helpText={helpText} forId={id}/>
      {newValue && newValue.map(
        (itemVal, idx) => {
          const childState = listState.getChildContext(idx)
          const labelText = getOptionTextFn ? getOptionTextFn(itemVal, childState.scope) : childState.hasData ? childState.getSummary() : ''

          return (
            <div key={'div' + id + '|' + idx} className={'d-flex mb-1'}
                 onKeyUp={null /* onEnter */}>
              <div style={{ width: 24, height: 24 }} className={'ml-1 mr-2'}/>
              <ChildLabel className={'rounded m-0'}>
                {idx + 1}. {labelText || ''}
              </ChildLabel>
              {listState && listState.mutable && (
                <div onClick={() => listState.deleteObject(idx)}>
                  <CloseIcon className={'m-2 timesBtn'}/>
                </div>
              )}
            </div>)
        })}

      <div className={'d-flex align-items-center'}>
        <CircleButton id={id + '|add'} icon={'icon-plus2'}
                      onClick={() => null}/>
        <div className={'flex-fill'}>
          <DropDown id={id + 'add'}
                    name={name}
                    label={null}
                    helpText={null}
                    searchable={true}
                    isList={false}
                    value={''}
                    context={context}
                    rtOptions={rtOptions}
                    optionQuery={optionQuery}
                    optFields={optFields}
                    onChange={(optVal) => {
                      if (listState && listState.mutable) {
                        listState.addNewObject(optVal)
                      }
                    }}
                    optionKeyName={optionKeyName}
                    getOptionTextFn={getOptionTextFn}
                    isInsideModal={isInsideModal}
          />
        </div>
      </div>
    </Fragment>
  )
}

export default DropDownList
